var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Button } from '@mui/material';
import { DialogTypes } from 'common/enums/components/dialog-types.enum';
import { TOURNAMENT } from 'common/graphql/queries/tournament/tournament';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useDispatch } from 'react-redux';
import { openDialog } from 'store/actions';
import TournamentTeamListItem from './TournamentTeamListItem';
var TournamentTeamsSettings = function (_a) {
    var _b;
    var tournamentId = _a.tournamentId;
    var _c = useQuery(TOURNAMENT, {
        variables: {
            id: tournamentId,
            showBasicFields: true,
            showTeams: true
        }
    }), data = _c.data, loading = _c.loading;
    var dispatch = useDispatch();
    var teams = (_b = data === null || data === void 0 ? void 0 : data.tournament) === null || _b === void 0 ? void 0 : _b.teams;
    var openCreateTournamentTeamDialog = function () {
        var _a;
        dispatch(openDialog({
            dialogType: DialogTypes.CreateTournamentTeam,
            dialogProps: {
                tournamentId: tournamentId,
                tournamentName: (_a = data === null || data === void 0 ? void 0 : data.tournament) === null || _a === void 0 ? void 0 : _a.name
            }
        }));
    };
    if (loading)
        return _jsx(CircularProgressMui, {}, void 0);
    return (_jsxs("div", __assign({ className: "flex flex-col space-y-40 w-full" }, { children: [_jsx("div", __assign({ className: "max-w-288" }, { children: _jsx(Button, __assign({ type: "button", onClick: openCreateTournamentTeamDialog }, { children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u0443" }), void 0) }), void 0), teams && (teams === null || teams === void 0 ? void 0 : teams.length) > 0 && (_jsx("div", __assign({ className: "flex flex-col space-y-10" }, { children: teams.map(function (team) {
                    return _jsx(TournamentTeamListItem, { team: team }, team.id);
                }) }), void 0))] }), void 0));
};
export default TournamentTeamsSettings;
